type Props = {};

import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./components/SideBar";

const Layout = (props: Props) => {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen w-screen">
      <Sidebar />
      <div className="flex-grow bg-secondary">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
